import { extract } from 'ricos-content/libs/extract';
import { fromTiptap } from 'ricos-converters';

class GetContentExtractorError extends Error {
}
class RicosContentQueryService {
  setEditor(editor) {
    this.editor = editor;
  }
  getContentExtractor() {
    if (!this.editor) {
      throw new GetContentExtractorError(
        "getContentExtractor called without initialize editor instance (setEditor)"
      );
    }
    const tiptapContent = this.editor.getJSON();
    const richContent = fromTiptap(tiptapContent);
    const nodes = richContent.nodes;
    return extract(nodes != null ? nodes : []);
  }
}

export { RicosContentQueryService };
//# sourceMappingURL=ContentQueryService.js.map
